import React from 'react';
import { Link } from 'react-router-dom';

const CancelPage = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-red-100 text-center p-4">
      <h1 className="text-4xl font-bold text-red-700 mb-4">Payment Cancelled ❌</h1>
      <p className="text-lg text-gray-700 mb-6">
        Looks like you cancelled the payment. No worries, you can try again!
      </p>
      <Link to="/" className="bg-red-600 text-white px-6 py-2 rounded hover:bg-red-700">
        Go Back Home
      </Link>
    </div>
  );
};

export default CancelPage;
